import { render, staticRenderFns } from "./BaseModalConfirm.vue?vue&type=template&id=4d07fb36&scoped=true&"
import script from "./BaseModalConfirm.vue?vue&type=script&lang=ts&"
export * from "./BaseModalConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./BaseModalConfirm.vue?vue&type=style&index=0&id=4d07fb36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d07fb36",
  null
  
)

export default component.exports